export const MUX_SOURCE_TYPE = 4;

export function isMuxVideo(video) {
  return Boolean(video) && Number(video.video_source_type) === MUX_SOURCE_TYPE;
}

export function isMuxPending(video) {
  return isMuxVideo(video) && ['uploading', 'preparing'].includes(video.mux_status);
}

const LABELS = {
  uploading: 'Upload not finished',
  preparing: 'Mux is preparing this video',
  ready: 'Ready',
  errored: 'Mux could not process this video',
};

export function muxStatusLabel(status) {
  return LABELS[status] || '';
}

// Spec: do not load Mux segments before the viewer presses play.
export function hlsPreload(video, autoplay) {
  return isMuxVideo(video) && !autoplay ? 'none' : 'auto';
}
